import { render, staticRenderFns } from "./m-tooltip.vue?vue&type=template&id=01cfa563&scoped=true"
import script from "./m-tooltip.vue?vue&type=script&lang=js"
export * from "./m-tooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01cfa563",
  null
  
)

export default component.exports